import React from 'react';

import { translate } from 'sharedreact/utils/LanguageSupport';
import Dialog from 'sharedreact/components/Dialog';

type Props = {
  language: string,
  show: boolean,
  userName: string,
  canCopyToClipboard: boolean,
  copyData: string,

  onCopy: () => void,
  onClose: () => void
};

class CopyTokenDialog extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      language, show, userName, canCopyToClipboard,
      copyData, onCopy, onClose
    } = this.props;

    const id: string = 'ae_dialog_copytoken';

    let title: string = '';
    let info: string = '';
    if (canCopyToClipboard) {
      title = translate('launcher.admin.tokens.copytoclipboard.title');
      info = translate('launcher.admin.tokens.copytoclipboard.info', userName);
    } else {
      title = translate('launcher.admin.tokens.manualcopy.title');
      info = translate('launcher.admin.tokens.manualcopy.info', userName);
    }

    return (
      <Dialog id={id}
        show={show}
        language={language}
        title={title}
        hideConfirmButton={!canCopyToClipboard}
        onClose={onClose}
        onConfirm={onCopy}
        primaryButton={canCopyToClipboard ? 'confirm' : undefined}
      >
        <div>{info}</div>
        {!canCopyToClipboard
        ? <textarea
          id={id + '_token'}
          className='webappslauncher-token-textarea'
          value={copyData}
          readOnly
        />
        : null
        }
      </Dialog>
    );
  }
}

export default CopyTokenDialog;
